import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.orders = ReducerFuncs }

export {
  Routes,
  Reducers
}
